<template>
    <page :tabs="tabs" :busy="busy">
        <router-view @handleBusy="handleBusy"></router-view>
    </page>
</template>

<script>
import page from '../generic/page/page.vue';
export default {
    components: { page },
    data() {
        return {
            busy: false,
        };
    },
    computed: {
        tabs() {
            return [
                {
                    title: 'Setup',
                    route: '/app/guest-verification/setup/',
                    active: this.$route.path === '/app/guest-verification/setup/',
                },
                {
                    title: 'Requested Verifications',
                    route: '/app/guest-verification/requested/',
                    active: this.$route.path === '/app/guest-verification/requested/',
                },
                {
                    title: 'Pending Verifications',
                    route: '/app/guest-verification/pending/',
                    active: this.$route.path === '/app/guest-verification/pending/',
                },
                {
                    title: 'Trusted Guests',
                    route: '/app/guest-verification/trusted-guests/',
                    active: this.$route.path === '/app/guest-verification/trusted-guests/',
                },
                {
                    title: 'Logs',
                    route: '/app/guest-verification/logs/',
                    active: this.$route.path === '/app/guest-verification/logs/',
                },
            ];
        },
    },
    methods: {
        handleBusy(value) {
            this.busy = value;
        },
    },
};
</script>

<style>
</style>